import Vue from 'vue'
import Vuex from 'vuex'
import Emkt from '../emkt'
import $ from 'jquery'
import {
  ADD_CART_LIST,
  ADD_CHECK_LIST,
  ADD_COMMENT_FROM_WAITCOMMENT,
  ADD_ORDER,
  ADD_WAITDELIVER_ORDER_FROM_WAITPAID_ORDER,
  ADD_WAITPAID_ORDER,
  CANCEL_ORDER_FROM_WAITPAID_ORDER,
  CLIENT_INFO,
  CLIENT_INFO_UPDATE,
  COMBINE_CART_LIST,
  DELETE_CART_LIST,
  ENTERPRISE_INFO_UPDATE,
  EXPRESSADDRESS_UPDATE,
  FIND_FILTERS,
  FINDER_FLAG,
  FINDER_RESULT_TOTAL,
  FINDER_SEARCH_TEXT,
  GENE_SEARCH_RESULT,
  HARD_GENE_INFO,
  POPUP_TEXT_RESULT,
  INIT_CART,
  INIT_MESSAGE,
  INVOICE_ADDRESS,
  INVOICE_TITLE,
  INVOICETITLE_INFO_UPDATE,
  LOGIN_STATE_UPDATE,
  MERCHDISEGROUP_UPDATE,
  MYORDER_UPDATE,
  QUERY_PARAMS_STORE,
  QUERY_TOTAL,
  REMOVE_ALL_CHECKLIST_FROM_CART_LIST,
  REMOVE_ALL_FROM_CART_LIST,
  REMOVE_FROM_CART_LIST,
  ROUTER_STORE,
  SEND_MESSAGE,
  SET_CART_LIST,
  SET_CURRENT_MYORDER_TABINDEX,
  SET_CURRENT_WAITPAY_ORDER,
  SET_SECPROMOTION_INFO,
  SET_SHOW_PRODUCT_IMAGE,
  SETCONTRCTINfFOBOX,
  UPDATE_CART_CONTENT,
  UPDATE_CHOSEN_MEMBER,
  UPDATE_CHOSEN_ORDER,
  UPDATE_CHOSEN_RESEARCH_INDEX,
  UPDATE_CHOSEN_RESEARCH_MEMBER,
  UPDATE_CUST_REMARK,
  UPDATE_CUST_REMARK1,
  UPDATE_DEPARTMENT_INFO,
  UPDATE_PROGRESSINFO,
  UPDATE_RESEARCHGROUP_MEMBER_MAP,
  UPDATE_RESEARCHGROUP_ORDER_MAP,
  UPDATE_RESEARCHGROUP_SET,
  UPDATE_SAVE_TO_DB_OR_LOCALSTORAGE,
  UPDATE_SECPROMOTION_INFO,
  UPDATE_SHOWBILLINFO,
  UPDATE_TOTAL_APPROVE_AMOUNT,
  UPDATE_WEAPP_MYORDERS,
  ORDER_MATERIAL_INFO,
  REASSEMBLE_ORDER_MATERIAL_INFO,
  MATERIALDETAIL_ORDERMATERIALID,
  UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET
} from './mutation-type.js'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    navTopLevel: false,
    // isLogin: false,
    cartList: {
      cartContent: {},               // original cartList
      saveToDBOrLocalStorage: false  // true -> DB  false -> localStorage
    },
    sessionInfo: {},
    findFilters: [],
    finderResultTotal: 0,
    finderFlag: false,
    enterpriseInfo: {},
    invoiceInfo: {},
    merchdiseGroup: [],
    messageSessions: [
      {
        id: 0,
        user: {
          name: '吉凯基因',
          img: 'dist/images/2.png'
        },
        messages: [
        ],
        merchantMessages: {},
        messagesAmount: 0,
        unreadMessagesAmount: 0
      }
    ],
    checkList: [],
    orderList: [],
    myOrder: {},
    geneSearchResult: {},
    remarkData: {},
    routerSrc: '',
    merchandiseQueryParams: {},
    queryTotal: {},
    finderSearchText: '',
    secInfo: '',
    showContractInfoBox: false,
    departmentInfo: {},
    showBillInfo: true,
    showProductImage: true,
    chosenResearchIndex: 0,
    chosenResearchMember: {},
    researchGroupSet: [],
    researchGroupMemberMap: {},
    chosenResearchGroupIndex: 0,
    secPromotionDetailObj: {},
    custRemark: '请填写具体靶点序列或靶点编号或合同号',
    custRemark1: '请避开以下靶点:',
    researchGroupOrderMap: {},
    chosenOrder: {},
    chosenMember: {},
    totalApproveAmount: 0,
    progressInfo: {},
    orderInfo: {},
    // 提交订单后，全局保存ordersubmit生成的订单
    currentWaitPayOrder: null,
    currentMyOrderTabIndex: -1,
    weappMyOrders: {},
    hardGeneInfo: [],
    gotoCart: false,
    orderMaterialInfo: [],
    reassembleOrderMaterialInfo: {},
    orderMaterialId: null,
    customerOpenId: '',
    hideCustomerService: false,
    researchApprovalGroupMember: null
  },
  mutations: {
    toggleCustomerService (state, status) {
      state.hideCustomerService = status
    },
    navTopLevel (state, top) {
      state.navTopLevel = top
    },
    gotoCart (state, value) {
      state.gotoCart = value
    },
    [UPDATE_WEAPP_MYORDERS] (state, orders) {
      state.weappMyOrders = {...orders}
    },
    [SET_CURRENT_MYORDER_TABINDEX] (state, tabindex) {
      state.currentMyOrderTabIndex = tabindex
    },
    [SET_CURRENT_WAITPAY_ORDER] (state, order) {
      state.currentWaitPayOrder = {...order}
    },
    [ADD_CART_LIST] (state, goodInfo) {
      goodInfo.isChecked = true
      Emkt.merchandiseWithMeta(goodInfo)
      let goods = state.cartList.cartContent
      let goodId
      if (goodInfo.categoryId === 20) {
        goodId = goodInfo.cartid
      } else if (goodInfo.categoryId === 99) {
        goodId = goodInfo.itemId
      } else {
        goodId = goodInfo.merchandiseId
        // 更新商品的cartId为商品ID
        goodInfo.cartid = goodInfo.merchandiseId
      }
      if (!goodId) {
        return
      }
      if (goods[goodId]) {
        if (goods[goodId].categoryId !== 7) {
          goods[goodId].productQuantity = 1
        } else {
          goods[goodId].productQuantity++
        }
      } else {
        goodInfo.productQuantity = 1
        goods[goodId] = goodInfo
      }
      // var arr = []
      // for (let i in goods) {
      //   let object = {}
      //   object[i] = goods[i]
      //   arr.push(object)
      // }
      // if (arr.length > 0) {
      //   arr.unshift(arr[arr.length - 1])
      //   arr.pop()
      //   console.log(goods, 'sssssssnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn')
      //   console.log(arr, 'sssssssnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn')
      //   let finalObject = {}
      //   arr.forEach(item => {
      //     for (let key in item) {
      //       finalObject[key] = item[key]
      //     }
      //   })
      //   console.log(finalObject, 'vvvvvvvvvvvvvvvvv')
      // }
      state.cartList = {...state.cartList}
    },
    [SETCONTRCTINfFOBOX] (state, data) {
      state.showContractInfoBox = data
    },
    [UPDATE_CUST_REMARK] (state, data) {
      state.custRemark = data
    },
    [UPDATE_CUST_REMARK1] (state, data) {
      state.custRemark1 = data
    },
    [DELETE_CART_LIST] (state, goodInfo) {
      let goods = state.cartList.cartContent
      let goodId
      if (goodInfo.categoryId === 20) {
        goodId = goodInfo.cartid
      } else if (goodInfo.categoryId === 99) {
        goodId = goodInfo.itemId
      } else {
        goodId = goodInfo.merchandiseId
      }
      if (goods[goodId]) {
        if (goods[goodId].productQuantity === 1) {
          delete goods[goodId]
        } else {
          goods[goodId].productQuantity --
        }
      }
      state.cartList = {...state.cartList}
    },
    [REMOVE_FROM_CART_LIST] (state, merchandiseId) {
      let goods = state.cartList.cartContent
      delete goods[merchandiseId]
      state.cartList = {...state.cartList}
    },
    [REMOVE_ALL_CHECKLIST_FROM_CART_LIST] (state) {
      let goods = state.cartList.cartContent
      console.log(state.checkList)
      for (let i = 0; i < state.checkList.length; i++) {
        if (state.checkList[i].categoryId === 20) {
          delete goods[state.checkList[i].cartid]
        } else if (state.checkList[i].categoryId === 99) {
          delete goods[state.checkList[i].itemId]
        } else {
          delete goods[state.checkList[i].cartid]
        }
      }
      // goods.forEach((item, index) => {
      //   if (item.categoryId)
      // })
      state.cartList = {...state.cartList}
    },
    [REMOVE_ALL_FROM_CART_LIST] (state) {
      state.cartList = {
        cartContent: {},               // original cartList
        saveToDBOrLocalStorage: false  // true -> DB  false -> localStorage
      }
    },
    [ADD_CHECK_LIST] (state, items) {
      state.checkList = items
    },
    [FINDER_FLAG] (state, items) {
      console.log(items)
      state.finderFlag = items
    },
    [INIT_CART] (state) {
      // 从localStorage中取出记录
      let initCart = Emkt.getLocalStorage('EmktBuyCart')
      // console.log('initCart', initCart)
      // 初始化购物车时，从小程序跳转过来，不读取本地购物车数据
      if (Emkt.isWapp) {
        state.cartList.cartContent = {}
      } else if (initCart) {
        state.cartList.cartContent = initCart  // 前台监听不到此变化，因为初始化购物车无需保存到本地
      }
    },
    [SET_CART_LIST] (state, cart) {
      console.log('isWapp set cart list')
      if (cart) {
        state.cartList = {
          cartContent: cart,
          saveToDBOrLocalStorage: true  // true -> DB  false -> localStorage
        }
      }
    },
    [ADD_ORDER] (state, order) {
      state.orderList.push(order)
    },
    [CLIENT_INFO] (state, clientInfo) {
      state.sessionInfo = clientInfo
    },
    [LOGIN_STATE_UPDATE] (state, login) {
      state.hasLogin = login
    },
    [CLIENT_INFO_UPDATE] (state, customerInfo) {
      state.sessionInfo = {
        'customerInfo': customerInfo
      }
    },
    [ENTERPRISE_INFO_UPDATE] (state, enterprise) {
      state.enterpriseInfo = {
        'enterpriseName': enterprise.enterpriseName,
        'enterpriseNo': enterprise.enterpriseNo,
        'locationName': enterprise.locationName,
        'regionName': enterprise.regionName
      }
    },
    [INVOICETITLE_INFO_UPDATE] (state, enterprise) {
      state.invoiceInfo = enterprise
    },
    [MERCHDISEGROUP_UPDATE] (state, merchdiseGroup) {
      state.merchdiseGroup = merchdiseGroup
    },
    [EXPRESSADDRESS_UPDATE] (state, expressInfo) {
      state.sessionInfo.expressAddress = expressInfo
    },
    [INVOICE_TITLE] (state, invoiceInfo) {
      state.sessionInfo.invoiceTitle = invoiceInfo
    },
    [MYORDER_UPDATE] (state, myOrder) {
      state.myOrder = myOrder
    },
    [FINDER_RESULT_TOTAL] (state, finderResultTotal) {
      state.finderResultTotal = finderResultTotal
    },
    [ADD_WAITPAID_ORDER] (state, waitPaidOrder) {
      if (state.myOrder.waitPaidOrders) {
        state.myOrder.waitPaidOrders.unshift(waitPaidOrder)
      }
    },
    [ADD_WAITDELIVER_ORDER_FROM_WAITPAID_ORDER] (state, waitPaidOrder) {
      let waitPaidOrders = state.myOrder.waitPaidOrders
      let waitDeliverOrders = state.myOrder.waitDeliverOrders
      if (waitPaidOrders) {
        let index = waitPaidOrders.indexOf(waitPaidOrder)
        if (index >= 0) {
          waitPaidOrders.splice(index, 1)
          waitDeliverOrders.unshift(waitPaidOrder)
        }
      }
    },
    [CANCEL_ORDER_FROM_WAITPAID_ORDER] (state, waitPaidOrder) {
      let waitPaidOrders = state.myOrder.waitPaidOrders
      let canceledOrders = state.myOrder.canceledOrders
      let index = waitPaidOrders.indexOf(waitPaidOrder)
      if (index >= 0) {
        waitPaidOrders.splice(index, 1)
        canceledOrders.unshift(waitPaidOrder)
      }
    },
    [ADD_COMMENT_FROM_WAITCOMMENT] (state, comment) {
      let waitCommentMerchandise = state.myOrder.waitCommentMerchandise
      let commentedMerchandise = state.myOrder.commentedMerchandise
      for (let i = 0; i < waitCommentMerchandise.length; i++) {
        if (waitCommentMerchandise[i].orderGuid === comment.orderId && waitCommentMerchandise[i].merchandiseGuid === comment.merchandiseId) {
          commentedMerchandise.unshift(waitCommentMerchandise[i])
          waitCommentMerchandise.splice(i, 1)
        }
      }
    },
    [GENE_SEARCH_RESULT] (state, geneData) {
      state.geneSearchResult = geneData
    },
    [HARD_GENE_INFO] (state, geneData) {
      state.hardGeneInfo = geneData
    },
    [POPUP_TEXT_RESULT] (state, remarkData) {
      state.remarkData = remarkData
    },
    [FINDER_SEARCH_TEXT] (state, finderSearchText) {
      state.finderSearchText = finderSearchText
    },
    [FIND_FILTERS] (state, findFilters) {
      state.findFilters = findFilters
    },
    // [CUST_DATA] (state, custdata) {
    //   state.custdata = custdata
    // },
    // 初始化消息
    [INIT_MESSAGE] (state) {
      // var self = store
      // window.gcapi('retrieveMyLeaveMessages').then((response) => {
      //   let data = response.body.result
      //   if (data) {
      //     self.getters.curMessageSession.leaveMessageStatus = data.leaveMessageStatus
      //     self.getters.curMessageSession.merchantMessages = data.merchantMessages
      //     self.getters.curMessageSession.messages = data.messages
      //     self.getters.curMessageSession.messagesAmount = data.messagesAmount
      //     self.getters.curMessageSession.unreadMessagesAmount = data.unreadMessagesAmount
      //   }
      // })
    },
    // 发送消息
    [SEND_MESSAGE] (state, content) {
      // var merchandiseGuid = null
      // // var merchandise = null
      // var message = content
      // var merchantNo = null
      //
      // if (content.merchandise) {
      //   merchandiseGuid = content.merchandise.merchandiseId
      //   // merchandise = content.merchandise
      //   merchantNo = content.merchandise.MerchantNo
      // } else {
      //   merchantNo = content.merchantNo
      // }
      // if (content.message) {
      //   message = content.message
      // }
      // window.gcapi('submitLeaveMessage', {message: message, messageType: Emkt.CONST_MESSAGE_TYPE_CUSTOMER_REQUEST, merchandiseGuid: merchandiseGuid, merchantNo: merchantNo}).then(function () {
      //   // window.gcapi('retrieveMyLeaveMessages').then((response) => {
      //   //   let data = response.body.result.merchantMessages
      //   //   if (data) {
      //   //     state.messageSessions[0].merchantMessages = data
      //   //   }
      //   //   console.log(state.messageSessions[0].merchantMessages)
      //   // })
      // })
    },
    [INVOICE_ADDRESS] (state, invoice) {
      state.sessionInfo.invoiceAddress = invoice
    },
    [ROUTER_STORE] (state, data) {
      state.routerSrc = data
      if (!data.query.des) {
        let id = data.query.id
        if (id) {
          Emkt.setLocalStorage('EmktCategoryID', data.query.id)
        } else {
          Emkt.setLocalStorage('EmktCategoryID', '-1')
        }
      }
    },
    [QUERY_PARAMS_STORE] (state, data) {
      state.merchandiseQueryParams = data
    },
    [QUERY_TOTAL] (state, data) {
      state.queryTotal = data
    },
    [SET_SECPROMOTION_INFO] (state, info) {
      state.secInfo = info
    },
    [UPDATE_SECPROMOTION_INFO] (state, updateInfo) {
      state.secInfo = Object.assign({}, state.secInfo, updateInfo)
    },
    [UPDATE_DEPARTMENT_INFO] (state, data) {
      state.departmentInfo = {...data}
    },
    [UPDATE_SHOWBILLINFO] (state, data) {
      state.showBillInfo = data
    },
    [SET_SHOW_PRODUCT_IMAGE] (state, data) {
      state.showProductImage = false
    },
    [COMBINE_CART_LIST] (state, data) {
      console.log('combine cart list')
      // DB中无购物车记录或者记录为空{} 更新'合并flag'，清空localStorage购物车
      if (data === '{}') {
        // console.log('no shopping cart result or content in DB')
        state.cartList.saveToDBOrLocalStorage = true
        state.cartList = {...state.cartList}
        Emkt.setLocalStorage('EmktBuyCart', {})
        return
      }
      const localCart = {...Emkt.getLocalStorage('EmktBuyCart')}
      const DBCart = JSON.parse(data)
      // 若localStorage购物车为空，数据库购物车更新cartList
      if (!localCart || Object.keys(localCart).length === 0) {
        state.cartList.cartContent = DBCart
        state.cartList.saveToDBOrLocalStorage = true // cartList得到初始化更新，由cartList生成的jsonString将保存到数据库
        state.cartList = {...state.cartList}   // 前台将监听到cart List的变化
        // console.log('local cart is empty 数据库购物车更新cartList  state.cartList.saveToDBOrLocalStorage = true')
      } else {
        // 合并localStorage和数据库的购物车
        for (let id in DBCart) { // insert DBCart into localCart
          if (id in localCart) {
            if (localCart[id].categoryId !== 20) {
              localCart[id].productQuantity += DBCart[id].productQuantity
            }
          } else {
            localCart[id] = DBCart[id]
          }
        }
        state.cartList.cartContent = localCart
        state.cartList.saveToDBOrLocalStorage = true
        state.cartList = {...state.cartList}   // 前台将监听到cart List的变化
        Emkt.setLocalStorage('EmktBuyCart', {}) // 清空本地购物车
        // console.log('cartList is combined!')
      }
    },
    [UPDATE_SAVE_TO_DB_OR_LOCALSTORAGE] (state, flag) {
      const oldFlag = state.cartList.saveToDBOrLocalStorage
      if (oldFlag === flag) {
        return
      }
      state.cartList.saveToDBOrLocalStorage = flag
      state.cartList = {...state.cartList}
    },
    [UPDATE_CART_CONTENT] (state, data) {
      state.cartList.cartContent = JSON.parse(data)
      console.log('data', JSON.parse(data))
      state.cartList = {...state.cartList}
    },
    [UPDATE_CHOSEN_RESEARCH_INDEX] (state, data) {
      state.chosenResearchIndex = data
    },
    [UPDATE_CHOSEN_RESEARCH_MEMBER] (state, data) {
      state.chosenResearchMember = {...data}
    },
    [UPDATE_RESEARCHGROUP_MEMBER_MAP] (state, data) {
      state.researchGroupMemberMap = {...data}
    },
    [UPDATE_RESEARCHGROUP_SET] (state, data) {
      state.researchGroupSet = [...data]
    },
    [UPDATE_CHOSEN_RESEARCH_INDEX] (state, data) {
      state.chosenResearchGroupIndex = data
    },
    [UPDATE_RESEARCHGROUP_ORDER_MAP] (state, data) {
      state.researchGroupOrderMap = data
    },
    [UPDATE_CHOSEN_ORDER] (state, data) {
      state.chosenOrder = data
    },
    [UPDATE_CHOSEN_MEMBER] (state, data) {
      state.chosenMember = data
    },
    [UPDATE_TOTAL_APPROVE_AMOUNT] (state, data) {
      state.totalApproveAmount = data
    },
    [UPDATE_PROGRESSINFO] (state, data) {
      state.progressInfo = data
    },
    [ORDER_MATERIAL_INFO] (state, data) {
      state.orderMaterialInfo = data
    },
    [REASSEMBLE_ORDER_MATERIAL_INFO] (state, data) {
      state.reassembleOrderMaterialInfo = data
    },
    [MATERIALDETAIL_ORDERMATERIALID] (state, data) {
      state.orderMaterialId = data
    },
    [UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET] (state, data) {
      state.researchApprovalGroupMember = {...data}
    }
  },
  getters: {
    hideCustomerService: state => state.hideCustomerService,
    isSFFlag: state => {
      let flag = false
      if (state.sessionInfo && state.sessionInfo.customerInfo && state.sessionInfo.customerInfo.ssoFlag === 1) {
        flag = true
      }
      return flag
    },
    hasLogin: state => {
      let sessionInfo = state.sessionInfo
      if (!sessionInfo) {
        return false
      }
      if (!sessionInfo.customerInfo) {
        return false
      }
      let customerInfo = state.sessionInfo.customerInfo

      if (customerInfo.customerNo === 'GUEST' || customerInfo.customerNo === '') {
        return false
      } else if (!customerInfo.customerNo && customerInfo.customerNo === '') {
        return false
      }
      return true
    },
    isWapp: state => {
      return Emkt.isWapp
    },
    customerNo: (state, getters) => {
      if (!getters.hasLogin) {
        return ''
      }
      return state.sessionInfo.customerInfo.customerNo
    },
    customerName: (state, getters) => {
      if (!getters.hasLogin) {
        return 'GUEST'
      }
      return state.sessionInfo.customerInfo.customerName
    },
    customerCreateDT: (state, getters) => {
      if (!getters.hasLogin) {
        return 'GUEST'
      }
      const customerCreateDT = state.sessionInfo.customerInfo.createDT
      return customerCreateDT && `${customerCreateDT.year}年${customerCreateDT.month + 1}月${customerCreateDT.dayOfMonth}日`
    },
    curMessageSession: state => {
      if (!state.messageSessions) {
        return null
      }
      return state.messageSessions[0]
    },
    secFlag: state => {
      const pro = state.secInfo
      // 初始化状态为 已结束
      if (!pro.startDT) {
        return 2
      }
      const startDT = new Date(pro.startDT.year, pro.startDT.month, pro.startDT.dayOfMonth, pro.startDT.hourOfDay, pro.startDT.minute, pro.startDT.second)
      const endDT = new Date(pro.endDT.year, pro.endDT.month, pro.endDT.dayOfMonth, pro.endDT.hourOfDay, pro.endDT.minute, pro.endDT.second)
      const now = pro.now
      // 单数限制
      if (pro.limitNumber > 0) {
        if (now < startDT) {
          return 0
        } else if (now < endDT && pro.usedNumber < pro.limitNumber) {
          return 1
        } else {
          return 2
        }
      } else { // 只有时间限制
        if (now < startDT) {
          return 0
        } else if (now < endDT) {
          return 1
        } else {
          return 2
        }
      }
    },
    isNewCustomerWithoutHistoryOrders: state => {
      const orders = state.myOrder
      if (!orders || JSON.stringify(orders) === '{}') {
        return null
      }
      // 根据订单历史判断是否是新用户=无已完成订单且无待收货订单
      const ordersToEvaluate = [...orders.waitDeliverOrders, ...orders.finishedOrders]
      const orderTimeSet = new Set()
      if (ordersToEvaluate.length > 0) {
        for (let order of ordersToEvaluate) {
          orderTimeSet.add(order.payDT)
        }
      }
      return orderTimeSet.size === 0
    },
    researchGroupDetailList: (state, getters) => {
      const detailList = []
      if (getters.customerNo) {
        for (let i = 0; i < state.researchGroupSet.length; i++) {
          const group = {...state.researchGroupSet[i]}
          const memberList = state.researchGroupMemberMap[group.researchGroupNo]
          for (let member of memberList) {
            if (member.memberNo === getters.customerNo) {
              group.approveType = member.approveType
              group.approveThreshold = member.approveThreshold
              group.monthlyLimit = member.monthlyLimit
              break
            }
          }
          detailList.push(group)
        }
      }
      return detailList
    },
    displayChosenResearchGroup: (state, getters) => {
      if (getters.researchGroupDetailList && getters.researchGroupDetailList.length > 0) {
        return getters.researchGroupDetailList[state.chosenResearchGroupIndex]
      }
      return null
    },
    researchGroupCharacter: (state, getters) => {
      if (!getters.customerNo || !getters.displayChosenResearchGroup) return ''
      if (getters.customerNo === getters.displayChosenResearchGroup.leaderNo) return 'leader'
      if (getters.customerNo === getters.displayChosenResearchGroup.approverNo) return 'approver'
    },
    researchGroupOrder: (state, getters) => {
      return state.researchGroupOrderMap
    },
    chosenOrder: (state, getters) => {
      return state.chosenOrder
    },
    // chooseMember: (state, getters) => {
    //   return state.chosenMember
    // },
    totalApproveAmount: (state, getters) => {
      return state.totalApproveAmount
    },
    progressInfo: (state, getters) => {
      return state.progressInfo
    },
    cartList: (state, getters) => {
      return state.cartList
    },
    getOrderMaterialInfo: (state, getters) => {
      return state.orderMaterialInfo
    },
    getReassembleOrderMaterialInfo: (state, getters) => {
      return state.reassembleOrderMaterialInfo
    },
    getOrderMaterialId: (state, getters) => {
      return state.orderMaterialId
    }
  }
})

var messageTimer
store.watch(
  (state) => state.messageSessions,
  (val) => {
    var self = store
    if (self.sessionInfo && self.sessionInfo.customerInfo) {
      clearInterval(messageTimer)
      messageTimer = setInterval(function () {
        window.gcapi('@retrieveMyResponeMessages').then((response) => {
          let leaveMessageInfo = response.body.result
          self.getters.curMessageSession.leaveMessageStatus = leaveMessageInfo.leaveMessageStatus
          // self.getters.curMessageSession.merchantMessages = leaveMessageInfo.merchantMessages
          if (leaveMessageInfo.messagesAmount && leaveMessageInfo.messagesAmount.length > 0) {
            var len = leaveMessageInfo.messagesAmount
            if (len > self.getters.curMessageSession.messagesAmount) {
              $.notification({
                title: '你有新消息',
                text: '请您查看新消息！',
                media: '<img src="/emktResources/resocurces/img/customerService.jpeg">',
                data: '请您查看新消息！',
                onClick: function (data) {
                  var router = window.app.$router
                  if (router) {
                    router.push({name: 'MessageManagement'})
                  }
                },
                onClose: function (data) {
                  // $.alert("Close "+data);
                }
              })
            }
            self.getters.curMessageSession.merchantMessages = leaveMessageInfo.merchantMessages
            // var lastMessage = messages[len - 1]
          }
        })
      }, 60 * 1000)
    }
  },
  {
    deep: true
  }
)
export default store



// WEBPACK FOOTER //
// ./src/store/index.js